<template>
    <div style="position: relative;">
        <el-button style="position: absolute;top:4px;right: 0;z-index: 1000;"  @click="openhy" type="text" color="#4F46E5">引用好友验证语</el-button>
        <el-tabs
            @tab-change = 'tabchange'
            v-model="editableTabsValue"
            type="card"
            editable
            style="min-width: 600px;"
            @edit="handleTabsEdit"
        >
            <el-tab-pane
            v-for="item in editableTabs.data"
            :key="item.name"
            :label="item.title"
            :name="item.name"
            >
                <div style="border: 1px solid #dcdfe6;border-radius: 5px;padding-bottom: 10px;width: 100%;">
                    <el-input
                    @blur="testBlur" class="t_textarea_nobod"  
                    placeholder="请输入文本内容，限50个字" v-model="item.content"  type="textarea" rows="7" maxlength="50"  clearable />
                    <el-button @click="addname(item)" style="margin-top: 10px;margin-left: 10px;">插入成员姓名</el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
    <cfriendtest v-if="islistshow" :islistshow="islistshow" @chooselist = 'chooselist' />
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Download,Upload } from '@element-plus/icons-vue'
import { bqlist } from '@/assets/js/common.js'
import cfriendtest from './cfriendtest.vue';
// 接受父级数据，注册事件
const props = defineProps(['copyyzy'])
const emits = defineEmits(['choosecheckmsg'])
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
   
   
})
watch(props.copyyzy, (newVal, oldVal) => {
            editableTabs.data = []
            if(newVal.data.length!=0){
                for(var x=0;x<newVal.data.length;x++){
                    editableTabs.data.push({
                        title: '第'+(x+1)+'组',
                        name: x+1,
                        content: newVal.data[x].content
                    });
                }
                editableTabsValue.value = 1
            }else{
                editableTabs.data.push({
                    title: '第1组',
                    name: 1,
                    content: ''
                });
                editableTabsValue.value = 1
            }
})

//验证信息

// const tabIndex = ref(1) //当前tab个数
const editableTabsValue = ref(1) //当前tab
//当前tab列表
const editableTabs = reactive(
    {
        data:[
            {
                title: '第1组',
                name: 1,
                content: '',
            },
        ]
    }
)
//编辑tab模块
const handleTabsEdit = (targetName, action)=>{
       
        if (action === 'add') {
          var lastnum = editableTabs.data[editableTabs.data.length-1].name*1
          let newTabName = ++lastnum + '';
            
          editableTabs.data.push({
            title: '第'+newTabName+'组',
            name: newTabName,
            content: ''
          });
          editableTabsValue.value = newTabName;
        
        }
        if (action === 'remove') {
        //   let newTabName = --tabIndex.value + '';
            if(editableTabs.data.length==1){
                return
            }
          let tabs = editableTabs.data;
          let activeName = editableTabsValue.value;
          
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                
                let nextTab = tabs[index + 1] || tabs[index - 1];
                console.log('nextTab')
                console.log(nextTab)
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          
          editableTabsValue.value = activeName;
          editableTabs.data = tabs.filter(tab => tab.name !== targetName);
        }
        //向父级传送数据
        emits('choosecheckmsg',editableTabs.data)
}
//切换tab
const tabchange = (pane)=>{
    console.log(pane)
    for(var x = 0;x<editableTabs.data.length;x++){
        if(editableTabs.data[x].name ==  pane){
            Blurindex.value = editableTabs.data[x].content.length
            console.log(Blurindex.value)
        }
    }
}
//储存焦点位置
const Blurindex = ref(0)
//获取焦点位置
const testBlur = (e)=>{
    console.log('失去焦点')
    console.log(e.srcElement.selectionStart)
    Blurindex.value = e.srcElement.selectionStart
    //向父级传送数据
    emits('choosecheckmsg',editableTabs.data)
}
//插入姓名
const addname = (row)=>{
    console.log(editableTabsValue.value)
    for(var x = 0;x<editableTabs.data.length;x++){
        if(editableTabs.data[x].name ==  row.name){
            var yuantest = editableTabs.data[x].content
            editableTabs.data[x].content= yuantest.slice(0,Blurindex.value)+'${name}'+yuantest.slice(Blurindex.value)
        }
    }
    //向父级传送数据
    emits('choosecheckmsg',editableTabs.data)
}

//列表是否展示
const islistshow = ref(false)

//验证语返回值
const chooselist = (val)=>{
    console.log('验证语返回值')
    console.log(val)
    if(val.length!=0){
        for(var x = 0;x<editableTabs.data.length;x++){
            if(editableTabs.data[x].name ==  editableTabsValue.value){
                editableTabs.data[x].content= val[0].content
            }
        }
        //向父级传送数据
        emits('choosecheckmsg',editableTabs.data)
    }
    
    islistshow.value = false
    
}
//打开验证语
const openhy = ()=>{
    islistshow.value = true
}
</script>
<style scoped>
:deep(.el-tabs__new-tab){
    margin-right: 470px;
}
</style>